module.exports = __webpack_public_path__ + "img/noticia-01.11f202dc.png";